import React from "react"
import { PageContent, CustomBreadcrumb } from "components/Common";
import StatisticsRealSale from "./StatisticsRealSale";
import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types"

const RESOURCE = ModuleIds.StatisticsRealSale;

const StatisticsRealSaleContainer = ({ t }) => {
    const titleTag = t("Thống kê doanh số thực")
    return (
        <PageContent title={t(titleTag)}>
            {/* Page Title */}
            < CustomBreadcrumb
                breadcrumbItem={titleTag}
                resource={RESOURCE}
                icon={<i className="bx bx-file" />}
            />
            {/* Page Body */}
            <StatisticsRealSale />
        </PageContent >
    )
}

StatisticsRealSaleContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["sitePage"])(StatisticsRealSaleContainer)